export const webhooksSuggestionsDictionary = {
  space: "space",
  name: "name",
  createdAt: "created at",
  slug: "ID",
} as { [key: string]: string };

export const sortItemOrder = ["name", "space", "enabled", "createdAt"];

export const EXCLUDED_FILTER_FIELDS = ["timestamp"];
